<div class="min-w-0 h-full  max-w-full  flex flex-col">
        <div class="w-full flex justify-between ">
                <div class="flex items-center"> <img src="../../assets/svg/powerGeneration.svg" alt="preview"> <span
                                class="font-normal  text-[#AEB9E1] sm:text-sm md:text-lg tracking-[2%] ml-1.5">{{"power_generation"|
                                translate}}</span> </div>
        </div>
        <div class="flex-1 min-h-0 min-w-0 w-full  overflow-hidden flex items-center">
                @if (
                chartOptions &&
                chartOptions.chart?.type &&
                chartOptions.series &&
                chartOptions.series.length > 0
                ) {
            <div class="flex flex-grow justify-center items-center w-full ">   <apx-chart class="w-full  text-black  max-w-full" [series]="chartOptions.series!"
                        [chart]="chartOptions.chart!" [xaxis]="chartOptions.xaxis!" [yaxis]="chartOptions.yaxis!"
                        [tooltip]="chartOptions.tooltip!" [dataLabels]="chartOptions.dataLabels!"
                        [stroke]="chartOptions.stroke!" [plotOptions]="chartOptions.plotOptions!"
                        [grid]="chartOptions.grid!" [markers]="chartOptions.markers!" [fill]="chartOptions.fill!"[legend]="chartOptions.legend!" ></apx-chart> </div>
                } @else {

                <div class="flex w-full justify-center items-center h-full sm:mt-10 md:mt-20 lg:mt-24">
                        <span class="text-xs dark:text-white">{{
                                "no_record_found" | translate
                                }}</span>
                </div>
                }


        </div>
</div>